import type { QueryClient } from "@tanstack/react-query";

/** Drop all Command-team React Query data (projects, sessions, messages, agents). */
export function clearCommandTeamQueryCache(queryClient: QueryClient) {
  const roots = [
    "command-projects",
    "command-project",
    "command-project-sessions",
    "command-project-sessions-page",
    "command-sessions",
    "command-messages",
    "command-agents",
    "command-agents-sidebar",
    "command-agent",
    "command-agent-header",
    "command-team-files",
  ] as const;

  for (const root of roots) {
    queryClient.removeQueries({ queryKey: [root] });
  }
}
